import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const UbsInvoiceIdSchema = z.int().positive().brand('ubs-invoice')
export type UbsInvoiceId = ZodInfer<typeof UbsInvoiceIdSchema>

export const UbsInvoiceId = (value: number): UbsInvoiceId =>
  UbsInvoiceIdSchema.parse(value)
